// import "@babel/polyfill";
import Vue from "vue";
// import VueMeta from 'vue-meta';
import Layout from "bootstrap-vue/es/components/layout";
import VTooltip from "v-tooltip";
import Cloudinary from "cloudinary-vue";
import VueAnimate from "vue-animate-scroll";

import App from "./App.vue";

import "./scss/index.scss";

Vue.config.productionTip = false;

// Vue.use(VueMeta);
Vue.use(Layout);
Vue.use(VTooltip);
Vue.use(VueAnimate);
Vue.use(Cloudinary, {
  configuration: {
    cloudName: "cloudinary",
    secure: true
  }
});

Vue.mixin({
  methods: {
    hexToRgb(hex) {
      return hex
        .replace(
          /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
          (m, r, g, b) => "#" + r + r + g + g + b + b
        )
        .substring(1)
        .match(/.{2}/g)
        .map(x => parseInt(x, 16));
    }
  }
});

new Vue({
  // mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
  render: h => h(App)
}).$mount("#app");
